export default __webpack_public_path__ + "static/austriaguides-adaa1a9cb80250aa403421ea5dc08cd6.png";